<template>
  <div id="contenedor-eliminar-tipo-archivo-contratista">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar tipo de archivo </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el tipo de archivo {{ tipoArchivoContratistaEliminar.descripcion }}?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarTipoArchivoContratista"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixTipoArchivosContratista from './mixTipoArchivosContratista';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarTipoArchivoContratista',
  mixins: [mixTipoArchivosContratista],
  props: {
    tipoArchivoContratistaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
